import PartnerActivityReportComponent from "../Components/MHL_Reports/PartnerActivityReportComponent";

const PartnerActivityReportPage = () => {
  return (
    <div>
      <PartnerActivityReportComponent />
    </div>
  );
};

export default PartnerActivityReportPage;
